<template>
  <div
    v-if="
      this.user.role == 'Administrator' ||
      this.user.role == 'Cashier' ||
      this.user.role == 'Verifier'
    "
  >
    <v-btn
      small
      @click="open"
      color="blue accent-4"
      class="white--text rounded-xl"
    >
      <v-icon class="mr-2">mdi-printer-outline</v-icon>Print Posted
      Payments</v-btn
    >
    <v-dialog persistent v-model="dialog" max-width="1200">
      <v-card>
        <v-sheet color="blue darken-2">
          <div class="pa-10">
            <h2 class="white--text display-1">Posted Payments</h2>
          </div>
        </v-sheet>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-select
                prepend-icon="mdi-account-cash"
                label="Cashier Name"
                :items="cashierAccounts"
                item-text="full_name"
                v-model="selectedCashier"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <div class="d-flex mt-5">
                <p class="mt-4 mr-2">From:</p>
                <input type="date" v-model="fromDate" />
                <p class="mt-4 mr-2 ml-4">To:</p>
                <input type="date" v-model="toDate" />
              </div>
            </v-col>
            <v-col>
              <v-btn class="mt-5" color="primary" @click="getPostedPayments()"
                ><v-icon class="mr-2">mdi-magnify</v-icon>Search</v-btn
              >
              <v-btn @click="print" color="success" class="mt-5 ml-3"
                ><v-icon class="mr-2">mdi-printer-outline</v-icon>Print
                Table</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Search"
                v-model="search"
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            :items="postedPayments"
            :headers="headers"
            :search="search"
          >
            <template v-slot:[`item.payment_date`]="{ item }">
              {{
                new Date(item.payment_date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  timeZone: "Asia/Manila",
                })
              }}</template
            >

            <template v-slot:[`item.created_at`]="{ item }">
              {{
                new Date(item.created_at).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  timeZone: "Asia/Manila",
                })
              }}</template
            >
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex-row justify-end">
          <v-btn @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      search: "",
      postedPayments: [],
      headers: [
        { text: "Payment ID", value: "id" },
        { text: "Contract No", value: "contract.contract_no" },
        { text: "Customer Name", value: "contract.customer_name" },
        { text: "PR Number", value: "pr_number" },
        { text: "Payment Date", value: "payment_date" },
        { text: "Amount", value: "amount_paid" },
        { text: "Posted By", value: "posted_by" },
        { text: "Posted Date", value: "created_at" },
      ],
      dialog: false,
      dates: [],
      menu: false,
      progress_dialog: false,
      cashierAccounts: [],
      fromDate: "",
      toDate: "",
      selectedCashier: null,
    };
  },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    ...mapGetters({
      // get any needed getters here
      accounts: "account/accounts",
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      set_notification: "notification/set_notification",
      print_posted_payments: "payment/print_posted_payments",
    }),

    async getPostedPayments() {
      //   console.log(this.selectedCashier, this.fromDate, this.toDate);
      if (this.selectedCashier && this.fromDate !== "" && this.toDate !== "") {
        this.progress_dialog = true;

        let cashier = this.selectedCashier;
        try {
          let response = await axios.get(
            `/getPostedPayments/${cashier}/${this.fromDate}/${this.toDate}`
          );
          // Handle the response data as needed
          this.postedPayments = response.data;
          this.progress_dialog = false;
        } catch (error) {
          console.error("Error fetching posted payments:", error);
          this.progress_dialog = false;
        }
      } else {
        this.set_notification({
          message: "Please select a cashier and date range",
          color: "error",
          showing: true,
          icon: "mdi-alert",
        });
      }
    },

    async get_accounts() {
      let response = await axios.get("/users");
      this.cashierAccounts = response.data.filter(
        (account) => account.role === "Cashier"
      );
      // Add a 'full_name' property to each cashier account for display
      this.cashierAccounts.forEach((account) => {
        account.full_name = `${account.last_name}, ${account.first_name} `;
      });
      this.cashierAccounts.sort((a, b) =>
        a.full_name.localeCompare(b.full_name)
      );

      console.log(this.cashierAccounts);
    },

    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    print() {
      if (this.postedPayments.length > 0) {
        // Create a new window for printing
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
          <html>
            <head>
              <title>Posted Payments</title>
              <style>
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid black; padding: 8px; text-align: left; }
              </style>
            </head>
            <body>
              <h1>Posted Payments</h1>
              <table>
                <thead><tr>${this.headers
                  .map((h) => `<th>${h.text}</th>`)
                  .join("")}</tr></thead>
                <tbody>${this.postedPayments
                  .map(
                    (item) =>
                      `<tr>${this.headers
                        .map(
                          (h) =>
                            `<td>${
                              h.value.includes(".")
                                ? h.value
                                    .split(".")
                                    .reduce((o, i) => o[i], item)
                                : item[h.value]
                            }</td>`
                        )
                        .join("")}</tr>`
                  )
                  .join("")}</tbody>
              </table>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      } else {
        this.set_notification({
          message: "No data to print. Please search for payments first.",
          color: "error",
          showing: true,
          icon: "mdi-alert",
        });
      }
    },
  },
  created() {
    // any initialization code here
    this.get_accounts();
  },
};
</script>
